export const colorClassName = (color) => (color ? `is-${color}` : undefined);
